import {useMutation, useQuery} from '@tanstack/react-query'
import {toast} from 'react-toastify'
import {API} from 'src/feature/bite/domain'
import {getTimeZone} from 'src/feature/bite/helpers/date'
import useRequestParams from 'src/feature/bite/hook/request'
import {useMemberPayment} from '../hook'

export const useMemberPaymentQuery = () => {
  const {errorMessage} = useRequestParams()
  const {paymentId, setMemberPayment} = useMemberPayment()

  return useQuery(
    ['MemberPayment', paymentId],
    async () => {
      const timeZoneOffset = getTimeZone()

      const Response = await fetch(`${API}/Item/PaymentLinkDetail`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({paymentLinkID: paymentId, language: 'en', timeZoneOffset}),
      })

      const Data = await Response.json()

      if (!Response.ok || !Data.responseResult.result) {
        return false
      }

      if (Data.response.data?.termsAndConditionsEnabled && Data.response.data?.termsAndConditions) {
        const conditionUrl = Data.response.data?.termsAndConditions
        const conditionsResponse = await fetch(conditionUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        })

        const dataValue = await conditionsResponse.text()
        const parser = new DOMParser()
        const doc = parser.parseFromString(dataValue, 'text/html')
        const contentView = doc.querySelector('#contentView')

        if (contentView) {
          Data.response.data.termsAndConditions = contentView.innerHTML
        } else Data.response.data.termsAndConditions = ''
      }

      setMemberPayment(Data.response.data)

      return true
    },
    {
      enabled: !!paymentId,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
      retry: false,
      onSuccess: () => {},
      onError: (error) => {
        toast.error(errorMessage, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          theme: 'light',
        })
      },
    }
  )
}

export const usePaymentLinkCreateCustomer = () => {
  const {errorMessage} = useRequestParams()

  return useMutation(
    ['PaymentLinkCreateCustomer'],
    async (values: any) => {
      const timeZoneOffset = getTimeZone()

      const Response = await fetch(`${API}/Item/PaymentLinkCreateCustomer`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...values,
          timeZoneOffset,
        }),
      })

      const Data = await Response.json()

      if (!Response.ok || !Data.responseResult.result) {
        return false
      }

      return Data
    },
    {
      onSuccess: () => {},
      onError: (error) => {
        toast.error(errorMessage, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          theme: 'light',
        })
      },
    }
  )
}

export const useCancelPaymentMutation = () => {
  const {errorMessage} = useRequestParams()
  const {paymentId} = useMemberPayment()

  return useMutation({
    mutationFn: async () => {
      const timeZoneOffset = getTimeZone()

      const Response = await fetch(`${API}/Item/CancelPaymentLink`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({paymentLinkID: paymentId, language: 'en', timeZoneOffset}),
      })

      const Data = await Response.json()

      if (!Response.ok || !Data.responseResult.result) {
        return false
      }

      // refresh page
      window.location.reload()

      return true
    },
    onError: (error) => {
      toast.error(errorMessage, {
        position: 'top-right',
        autoClose: 5000,
      })
    },
  })
}

// export const useGetPaymentLinkDetail = () => {
//   const { errorMessage } = useRequestParams();
//   const { paymentId } = useMemberPayment();

//   return useMutation({
//     mutationFn: async () => {
//       const Response = await fetch(`${API}/Item/GetPaymentLink/${paymentId}`, {
//         method: 'GET',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//       })

//       const Data = await Response.json()

//       console.log(Data)

//       return Data
//     },
//     onError: (error) => {
//       toast.error(errorMessage, {
//         position: 'top-right',
//         autoClose: 5000,
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: false,
//         progress: undefined,
//         theme: 'light',
//       })
//     },
//   })
// }
